
    import "/home/git/waysglob/website/src/pages/index/cover/index.module.scss.FARM_CSS_MODULES?32502d81";
    
    export default {"cover": `cover-5ba950f2`,"button": `button-5ba950f2`}
    